// src/components/OnboardingTour/TourTooltip.jsx

import React from 'react';
import { Box, Typography, Button, IconButton, Paper, Divider } from '@mui/material';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import CloseIcon from '@mui/icons-material/Close';

export const TourTooltip = ({
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
  isLastStep,
}) => (
  <Paper
    {...tooltipProps}
    elevation={8}
    sx={{
      borderRadius: 3,
      maxWidth: 350,
      bgcolor: 'background.paper',
      border: '1px solid',
      borderColor: 'divider',
      overflow: 'hidden', 
    }}
  >
    {/* Header Section */}
    <Box sx={{ p: 2, display: 'flex', alignItems: 'center', bgcolor: 'action.hover' }}>
        <LightbulbIcon sx={{ color: 'primary.main', mr: 1.5 }} />
        <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
          {step.title}
        </Typography>
        <IconButton {...closeProps} aria-label="close" size="small">
            <CloseIcon fontSize="small" />
        </IconButton>
    </Box>
    <Divider />

    {/* Content Section */}
    <Box sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
            {step.content}
        </Typography>
    </Box>

    {/* Footer Section */}
    <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: 'action.hover', borderTop: 1, borderColor: 'divider' }}>
      <Typography variant="caption" color="text.secondary">
        Step {index + 1} of {step.size}
      </Typography>
      <Box>
        {index > 0 && (
          <Button {...backProps} sx={{ mr: 1, borderRadius: '20px' }}>
            Back
          </Button>
        )}
        <Button {...primaryProps} variant="contained" sx={{ borderRadius: '20px' }}>
          {isLastStep ? 'Finish' : 'Next'}
        </Button>
      </Box>
    </Box>
  </Paper>
);
